import React from 'react';
import CourseFormCreate from './CourseFormCreate';
import CourseFormEdit from './CourseFormEdit';

/**
 * 课程表单包装组件（向后兼容）
 * @deprecated 请直接使用 CourseFormCreate 或 CourseFormEdit
 * 
 * 此组件保留用于向后兼容，新代码应该：
 * - 新增课程：使用 CourseFormCreate
 * - 编辑课程：使用 CourseFormEdit
 */
const CourseFormView = ({ editMode = false, initialData = {}, isSaving = false, onBack, onSave }) => {
  // 根据 editMode 渲染对应的专用组件
  if (editMode) {
    return (
      <CourseFormEdit
        initialData={initialData}
        isSaving={isSaving}
        onBack={onBack}
        onSave={onSave}
      />
    );
  }

  return (
    <CourseFormCreate
      isSaving={isSaving}
      onBack={onBack}
      onSave={onSave}
    />
  );
};

export default CourseFormView;
